'use client';

import { useTransition } from 'react';
import { ColorButton } from '@packages/shared/src/ui/ColorButton/ColorButton';
import type { FragmentType } from '@packages/gql/generated/shopping';
import type { ColorTileFragmentFragmentDoc } from '@packages/gql/generated/shopping/ColorTileFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';
import type { VariationSelectionOnSelectHandler } from '../../types';
import { templateNames } from '../../../hooks/useResponsiveAkamaiTemplate/config';
import { useVariationFormattedLink } from '../../utils/useVariationFormattedLink';

/* GraphQL */ `
  fragment ColorTileFragment on ProductDimensionValue {
    displayText
    image
    isSelected
    rgb
    sku
  }
`;

export type ColorTileProps = VariationSelectionOnSelectHandler & {
  /**
   * The GraphQL ProductDimensionValue data for the given product
   */
  data: FragmentType<typeof ColorTileFragmentFragmentDoc>;
};

export const ColorTile = ({ data, onSelect }: ColorTileProps) => {
  const { displayText, image, isSelected, rgb, sku } =
    unmask<typeof ColorTileFragmentFragmentDoc>(data);

  const [isPending, startTransition] = useTransition();
  const { getOnSelectCallback } = useVariationFormattedLink();
  const onClickHandler = getOnSelectCallback({ sku, onSelect });

  return (
    <ColorButton
      onClick={() => startTransition(() => onClickHandler())}
      minimal={false}
      image={image ? `${image}?${templateNames.variationSelect}` : undefined}
      fitBackgroundImage
      color={rgb ? `#${rgb}` : undefined}
      name={displayText || ''}
      active={!!isSelected}
      isSelected={isPending}
    />
  );
};
